stateProviders.push({
    name: 'schoolside.resources.parentFeedback.parentFeedbackContent',
    url: '/parentFeedbackContent',
    templateUrl: 'fast/submodules/schoolside/resources/parentFeedback/parentFeedbackContent/partials/parentFeedbackContent.html?v=' + versionNo,
    controller: 'parentFeedbackContentController',
    resolve: {
    	items: function(ParentCommentsModelService) {
    		return ParentCommentsModelService.resolveData();
    	}
    }
});